import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./DiscountedAccommodationTag.scss";
import IconPercentSquare from "app/pages/.shared/static/icons/IconPercentSquare";

const DiscountedAccommodationTag = () => {
	return (
		<div className="discounted-accommodation-tag" data-testid="discounted-accommodation-tag">
			<IconPercentSquare />
			<Typography
				variant={TYPOGRAPHY_VARIANTS.SMALL}
				isBold
				className="discounted-accommodation-tag__label"
			>
				<FormattedMessage id="product.discounted.accommodation.tag" />
			</Typography>
		</div>
	);
};

export default memo(DiscountedAccommodationTag);
